/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    npi: string | null;
    /**
     * 
     */
    credential?: string | null;
    /**
     * 
     */
    address_line?: string | null;
    /**
     * 
     */
    city?: string | null;
    /**
     * 
     */
    state?: string | null;
    /**
     * 
     */
    zip?: string | null;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner(value: object): value is FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'],
        'credential': json['credential'] === undefined ? undefined : json['credential'] === null ? null : json['credential'],
        'address_line': json['address_line'] === undefined ? undefined : json['address_line'] === null ? null : json['address_line'],
        'city': json['city'] === undefined ? undefined : json['city'] === null ? null : json['city'],
        'state': json['state'] === undefined ? undefined : json['state'] === null ? null : json['state'],
        'zip': json['zip'] === undefined ? undefined : json['zip'] === null ? null : json['zip'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSONTyped(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'npi': value['npi'],
        'credential': value['credential'],
        'address_line': value['address_line'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
    };
}

